import { ReactNode } from 'react';
import { SortableContainer, SortableElement, SortableHandle } from 'react-sortable-hoc';

interface ISortableProps {
  children: ReactNode;
}

export const DragDropList = SortableContainer(({ children }: ISortableProps) => <>{children}</>);
export const DragDropListItem = SortableElement(({ children }: ISortableProps) => <>{children}</>);
export const DragHandle = SortableHandle(({ children }: ISortableProps) => <>{children}</>);
